const login = {
  userPlaceholder: "กรุณากรอกชื่อผู้ใช้",
  userError: "กรุณากรอกชื่อผู้ใช้",
  pwdPlaceholder: "กรุณากรอกรหัสผ่าน",
  pwdError: "กรุณากรอกรหัสผ่าน",
  login: "เข้าสู่ระบบ"
} 
export default login